export default __webpack_public_path__ + "static/media/stormchains.b899319c.png";